import { Component, OnInit } from "@angular/core";
import { SettingsService } from "../../services/settings.service";

@Component({
  selector: "settings-panel",
  templateUrl: "./settings-panel.component.html",
  styleUrls: ["./settings-panel.component.css"],
})
export class SettingsPanelComponent implements OnInit {
  showListByBranch = false;

  constructor(private settings: SettingsService) {}

  ngOnInit(): void {
    this.settings.get<boolean>("showListByBranch", false).subscribe((value) => {
      this.showListByBranch = value;
    });
  }

  onToggle(): void {
    this.settings.set("showListByBranch", this.showListByBranch);
  }
}
